import axios from 'axios';

import { backendUrl } from '../../config';
import {
  UserModel,
  UserMetaGenres,
  UserMetaArtists,
} from './useBackendLoginHook.types';

export const backendClientPublic = () => {
  return {
    register: async (data: {
      artists: UserMetaArtists | null;
      user: UserModel | null;
      genres: UserMetaGenres | null;
    }) => {
      const url = `${backendUrl}/api/v1/users/web/register`;
      const result = await axios.post(url, data);

      if (result.status === 200 && result?.data?.user) {
        return result.data.user;
      }

      throw new BackendError(result.statusText);
    },
  };
};

export const backendClient = (spotifyId: string) => {
  return {
    onboarding: async (data: {
      club: string;
      bar: string;
      country: string;
      city: string;
    }) => {
      const url = `${backendUrl}/api/v1/users/web/onboarding`;

      const result = await axios.post(url, { ...data, spotifyId });

      if (result.status === 200 && result?.data?.city?.clubs) {
        return result.data.city.clubs;
      }

      return [];
    },
  };
};

export default backendClient;

class BackendError extends Error {
  constructor(message: string) {
    super(message); // (1)
    this.name = 'ValidationError'; // (2)
  }
}
